import { isElementInViewport, when } from '../helpers/helpers';
import { debounce } from 'lodash';
const JS_NAV_CLASS = 'js-in-page-nav';
const JS_NAV_ITEM_CLASS = 'js-in-page-nav-item';
const JS_BLACK_BG = 'js-in-page-nav-inverse';

// generic nav item classes defined in sass and the inverse for black bgs
const NAV_ITEM_CLASS = 'in-page-nav__item';
const NAV_ITEM_CLASS_INVERSE = `${NAV_ITEM_CLASS}--inverse`;

// generic nav item active classes and the inverse for black bgs
const NAV_ITEM_ACTIVE_CLASS = `${NAV_ITEM_CLASS}--active`;
const NAV_ITEM_ACTIVE_CLASS_INVERSE = `${NAV_ITEM_ACTIVE_CLASS}-inverse`;
const SLIDE_IN_CLASS = 'in-page-nav--slide-in';

const DEFAULT_NAV_ELEMENTS_ARRAY = [
  'overview',
  'design',
  'products',
  'swatches',
  'compare',
  'color-location',
];

/**
 *
 * @param {string} navId - id of navigation element
 * @param {string []} arrayOfElementsToTrack - array of ids of dom nodes we want to track
 * @returns {undefined} - function is a side effect
 */
function inPageNav(navId, arrayOfElementsToTrack) {
  const nav = document.getElementById(navId);

  if (nav) {
    slideInNavBar(nav);
    // create an array from the nav to iterate over
    const navItems = Array.from(nav.getElementsByClassName(JS_NAV_ITEM_CLASS));

    // remove the activeClass from all nav items
    const cleanNavItems = navItems.map(cleanUpNavItems);

    // map over the ids of elements we're tracking
    arrayOfElementsToTrack.map(function elemsTracker(id) {
      return makeElementsTrackable(id, navItems);
    });
  }
}

// Add the slide in class to the nav bar
// if it doesn't have it already and the window scroll is greater than the top of nav
// nav by default is positioned in the middle of the screen and off to the left
function slideInNavBar(nav) {
  if (nav) {
    if (!nav.classList.contains(SLIDE_IN_CLASS)) {
      if (window.scrollY > nav.getBoundingClientRect().top) {
        addClasses(nav, [SLIDE_IN_CLASS]);
      }
    } else if (window.scrollY < nav.getBoundingClientRect().top) {
      removeClasses(nav, [SLIDE_IN_CLASS]);
    }
  }
}

// map function that cleans up nav items
function cleanUpNavItems(el) {
  removeClasses(el, [
    NAV_ITEM_ACTIVE_CLASS,
    NAV_ITEM_ACTIVE_CLASS_INVERSE,
    NAV_ITEM_CLASS_INVERSE,
  ]);
}

function makeElementsTrackable(id, navArray) {
  // clean up the nav items and return the activeClass we want
  // can be inverted or regular
  let activeClasses = handleNavItemStyling(id, JS_BLACK_BG, navArray);

  // when the element is in view, we want to find the active nav item
  const inView = when(isElementInViewport, findActiveNavItem);

  // find the nav item that has the same href as the active element in the viewport
  const foundNavItem = inView(id, navArray);

  // if we have a found nav item, add active class
  if (foundNavItem) {
    addClasses(foundNavItem, activeClasses);
  }
}

function handleNavItemStyling(id, aClass, navArray) {
  if (elHasClassAndInView(id, aClass)) {
    // a side effect needed to add inverse classes to nav items
    navArray.map(el => addClasses(el, [NAV_ITEM_CLASS_INVERSE]));
    return [NAV_ITEM_ACTIVE_CLASS, NAV_ITEM_ACTIVE_CLASS_INVERSE];
  }

  if (elDoesntHaveClassAndInView(id, aClass)) {
    // a side effect needed to remove invesrse classes to item
    navArray.map(el => removeClasses(el, [NAV_ITEM_CLASS_INVERSE]));
    return [NAV_ITEM_ACTIVE_CLASS];
  }

  return '';
}

function elDoesntHaveClassAndInView(id, aClass) {
  return !elHasClass(id, aClass) && isElementInViewport(id);
}

function elHasClassAndInView(id, aClass) {
  return elHasClass(id, aClass) && isElementInViewport(id);
}

function elHasClass(id, aClass) {
  const el = document.getElementById(id);
  if (el) {
    return el.classList.contains(aClass);
  }
  return false;
}

function findActiveNavItem(id, navList) {
  const found = navList.filter(el => el.hash === `#${id}`);
  if (found.length > 0) {
    return found[0];
  }
}

/**
 *
 * @param {HTMLElement} el - Dom element to maninpulate
 * @param {string []} classes - classes to remove
 * @returns HTMLElement
 */
function removeClasses(el, classes) {
  el.classList.remove(...classes);
  return el;
}

/**
 *
 * @param {HTMLElement} el - the element to add a class to
 * @param {string []} classes - string array of classes to add
 * @returns HTMLElement
 */
function addClasses(el, classes) {
  el.classList.add(...classes);
  return el;
}

window.addEventListener(
  'scroll',
  debounce(function(event) {
    inPageNav(JS_NAV_CLASS, DEFAULT_NAV_ELEMENTS_ARRAY);
  }, 50)
);

const publicApi = {
  init: inPageNav,
};

export default publicApi;
